import apolloErrorHandler from '@frontend/ll-fe-tracker/errorProcessor/handlers/apolloErrorLink'
import { onError } from '@apollo/client/link/error'

export default function (context) {
  const errorLink = onError(apolloErrorHandler)

  // Custom function to get token - prioritize internal token over external token
  const getAuth = () => {
    const { app } = context
    const internalToken = app.$cookie.get('laAccessToken')
    const externalToken = app.$cookie.get('accessToken')

    const token = internalToken || externalToken
    return token ? `Bearer ${token}` : ''
  }

  const config = {
    link: errorLink,
    httpEndpoint: process.env.NUXT_ENV_ACADEMY_GRAPHQL_ENDPOINT,
    getToken: () => {
      const { app } = context
      const internalToken = app.$cookie.get('laAccessToken')
      const externalToken = app.$cookie.get('accessToken')
      return internalToken || externalToken
    },
    persisting: false,
    websocketsOnly: false,
    authenticationType: 'Bearer',
    getAuth,
    inMemoryCacheOptions: {
      addTypename: false,
    },
  }
  return config
}
